import { Controller } from "@hotwired/stimulus"

// controls cookies
// uses [Cookie Store API](https://developer.mozilla.org/en-US/docs/Web/API/CookieStore)
export default class extends Controller {
  async toggle({ params: { key }}) {
    if (await cookieStore.get(key)) {
      await cookieStore.delete(key)
    } else {
      await cookieStore.set(key, '1')
    }
  }
}
